module.exports = __webpack_public_path__ + "static/media/linkeln.b1e0ce35.svg";